enum UserType {
  DEFAULT= "DEFAULT",
  VESSEL="VESSEL",
  OFFICE = "OFFICE",
  ADMIN = "ADMIN"
}

export default UserType;